import React from 'react';
import PropTypes from 'prop-types';
import { classNames } from 'utils';

import './storefront.scss';

export default class StorefrontThemeStyles extends React.PureComponent {
  static propTypes = {
    theme: PropTypes.object.isRequired,
    onChangeStyle: PropTypes.func,
  };

  state = {
    styleId: null,
    styleAssets: null,
    showThemeInfo: false,
    showAppInfo: false,
  };

  componentDidMount() {
    const { theme, onChangeStyle } = this.props;

    if (theme?.styles?.length > 0) {
      const style = theme.styles[0];
      const styleAssets = theme.style_assets?.find(
        (styleAssets) => styleAssets.id === style?.id,
      );

      this.setState({ styleId: style?.id, styleAssets });

      if (onChangeStyle) {
        onChangeStyle(style?.id, styleAssets);
      }
    }
  }

  onClickStyle = (event) => {
    event.preventDefault();
    const { theme, onChangeStyle } = this.props;
    const { id } = event.currentTarget.dataset;

    const styleAssets = theme?.style_assets?.find(
      (styleAssets) => styleAssets.id === id,
    );

    this.setState({ styleId: id, styleAssets });

    if (onChangeStyle) {
      onChangeStyle(id, styleAssets);
    }
  };

  renderStyle(style) {
    const { styleId } = this.state;
    const { id, label, color, color_alt } = style;

    const background = color_alt
      ? `linear-gradient(135deg, ${color} 0 50%, ${color_alt} 50% 100%)`
      : color;

    return (
      <a
        key={id}
        href=""
        className={classNames('storefront-apps-styles-swatch', {
          selected: styleId === id,
        })}
        title={label}
        data-id={id}
        onClick={this.onClickStyle}
      >
        <div
          className="storefront-apps-styles-swatch-colors"
          style={{ background }}
        />
      </a>
    );
  }

  render() {
    const { theme } = this.props;

    if (!theme?.styles?.length) {
      return null;
    }

    return (
      <div className="storefront-apps-styles">
        {theme?.styles.map((style) => this.renderStyle(style))}
      </div>
    );
  }
}
